import {Component, Input, OnInit} from '@angular/core';
import {TranslationService} from '@lv1871/core';

@Component({
    selector: 'lv-inline-fehlermeldung',
    templateUrl: './inline-fehlermeldung.component.html',
    styleUrls: ['./inline-fehlermeldung.component.scss'],
    standalone: false
})
export class InlineFehlermeldungComponent implements OnInit {

  @Input()
  translationKeyFehlermmeldung: string;

  public fehlermeldung: string;
  constructor(private _translationService: TranslationService) {  }

  ngOnInit(): void {
    this.fehlermeldung = this._translationService.translate(this.translationKeyFehlermmeldung);
  }

}
